import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ModalIconComponent } from 'src/app/theme/components/modal-icon/modal-icon.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {

  constructor(private dialog: MatDialog) { }
  dialogRef: MatDialogRef<ModalIconComponent>;

  public open(options) {
    this.dialogRef = this.dialog.open(ModalIconComponent, {
      height: 'auto',
      width: options.width ? options.width : '700px',
      autoFocus: false,
      restoreFocus: false,
      disableClose: options.disableClose ? options.disableClose : false,
      data: {
        icon: options.icon,
        title: options.title,
        content: options.content,
        bullet: options.bullet,
        bold: options.bold,
        confirmbtn: options.confirmbtn,
        cancelbtn: options.cancelbtn,
        msgSucces: options.msgSucces
      }
    });
  }

  public confirmed(): Observable<any> {

    return this.dialogRef.afterClosed().pipe(take(1), map(res => {
      return res;
    }
    ));
  }

}
